import { RichText } from './post'

export enum MatchElementTypes {
  chipText = 'chip text',
  chipBackground = 'chip background',
  resultValue = 'result value',
  progressBar = 'progress bar',
  skillTitle = 'skill title',
}

export enum MatchResults {
  great = 'GREAT',
  good = 'GOOD',
  ok = 'OK',
  bad = 'BAD',
}

type chipTextType = 'chip text'
type chipBackgroundType = 'chip background'
type resultValueType = 'result value'
type progressBarType = 'progress bar'
type skillTitleType = 'skill title'
export type MatchElementType =
  | chipTextType
  | chipBackgroundType
  | resultValueType
  | progressBarType
  | skillTitleType

export interface MatchVariant {
  variant: 'Great' | 'Good' | 'Ok' | 'Bad'
  text: RichText
}

export interface MatchTitlesAndDescriptions {
  __typename: 'ContentfulMatchTitlesAndDescriptions'
  contentful_id: string
  variants: MatchVariant[]
  codeClasses: string[] | null
}
